import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18.5",
  height: "18.5"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g fill=\"none\" stroke=\"#fff\" stroke-linejoin=\"round\" stroke-width=\"1.5\" data-name=\"Ikona MENU Dashboard\" transform=\"translate(.75 .75)\"><rect width=\"7\" height=\"7\" data-name=\"Rectangle 2661\" rx=\"1.5\"></rect><rect width=\"7\" height=\"7\" data-name=\"Rectangle 4827\" rx=\"1.5\" transform=\"translate(0 10)\"></rect><rect width=\"7\" height=\"7\" data-name=\"Rectangle 4828\" rx=\"1.5\" transform=\"translate(10)\"></rect><rect width=\"5\" height=\"4.911\" data-name=\"Rectangle 4829\" rx=\"1\" transform=\"translate(10 10)\"></rect></g>", 1)
  ]))]))
}
export default { render: render }